import { Routes } from "@angular/router";
import { BootstrapAthleteComponent } from "./components/bootstrap-athlete/bootstrap-athlete.component";
import { ProxyAthleteComponent } from './components/proxy-athlete/proxy-athlete.component';
const ɵ0 = {
    reuse: true
}, ɵ1 = {
    reuse: true
}, ɵ2 = {
    reuse: true
}, ɵ3 = {
    reuse: true
}, ɵ4 = {
    reuse: true
}, ɵ5 = {
    reuse: true
}, ɵ6 = {
    reuse: true
}, ɵ7 = {
    reuse: true
}, ɵ8 = () => import("./athlete-quotes/athlete-quotes.module.ngfactory").then(m => m.AthleteQuotesModuleNgFactory), ɵ9 = {
    reuse: true
}, ɵ10 = () => import("./athlete-wcup-ranking/athlete-wcup-ranking.module.ngfactory").then(m => m.AthleteWcupRankingModuleNgFactory), ɵ11 = {
    reuse: true
};
const routes = [
    {
        path: 'photos/:id',
        component: ProxyAthleteComponent
    },
    {
        path: ':id',
        component: BootstrapAthleteComponent,
    },
    {
        path: ":id/:name",
        component: BootstrapAthleteComponent,
        data: ɵ0,
        children: [
            {
                path: "biography",
                loadChildren: "./athlete-biography/athlete-biography.module#AthleteBiographyModule",
                data: ɵ1
            },
            // Redirections for insights.
            {
                path: "biography/statistics",
                redirectTo: "statistics"
            },
            {
                path: "biography/records",
                redirectTo: "records"
            },
            {
                path: "biography/results",
                redirectTo: "results"
            },
            // END redirections
            {
                path: "statistics",
                loadChildren: "./athlete-statistics/athlete-statistics.module#AthleteStatisticsModule",
                data: ɵ2
            },
            {
                path: "matches",
                loadChildren: "./athlete-matches/athlete-matches.module#AthleteMatchesModule",
                data: ɵ3
            },
            {
                path: "results",
                loadChildren: "./athlete-results/athlete-results.module#AthleteResultsModule",
                data: ɵ4
            },
            {
                path: "records",
                loadChildren: "./athlete-records/athlete-records.module#AthleteRecordsModule",
                data: ɵ5
            },
            {
                path: "photos",
                loadChildren: "./athlete-photos/athlete-photos.module#AthletePhotosModule",
                data: ɵ6
            },
            {
                path: "news",
                loadChildren: "./athlete-news/athlete-news.module#AthleteNewsModule",
                data: ɵ7
            },
            {
                path: "quotes",
                loadChildren: ɵ8,
                data: ɵ9
            },
            {
                path: "world-cup",
                loadChildren: ɵ10,
                data: ɵ11
            }
        ],
    },
];
export class AthleteRoutingModule {
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11 };
